module.exports = __webpack_public_path__ + "img/default-picture.6bda9bfd.jpg";